import React, {useState} from 'react';
import {PublicEventDTO, PublicTableDTO} from "../home/types";
import {FileDoneOutlined} from "@ant-design/icons";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import {LauncherReservationConfirmationForm} from "./LauncherReservationConfirmationForm";

export type ReservationButtonProps = {
    table: PublicTableDTO;
    event: PublicEventDTO;
}

export const ReservationButton: React.FC<ReservationButtonProps> = (props) => {
    const {table, event} = props;
    const {t} = useTranslation();
    const [engaged, setEngaged] = useState<boolean>(false);

    if (!engaged) {
        return (
            <Button type={"primary"} size={"large"} style={{width: '100%', backgroundColor: 'limegreen'}}
                    icon={<FileDoneOutlined />}
                    onClick={() => setEngaged(true)}
            >
                {t('reservation.action')}
            </Button>
        )
    }

    return (
        <LauncherReservationConfirmationForm table={table} event={event} />
    )
}